import { ElementEventStrategy } from './ElementEventStrategy';
import { PageEventStrategy } from './PageEventStrategy';
var EventStrategyResolver = /** @class */ (function () {
    function EventStrategyResolver() {
    }
    EventStrategyResolver.prototype.resolveStrategyByEventType = function (context, props) {
        switch (props.event) {
            case 'ElementClick':
            case 'ElementMouseOver':
                return new ElementEventStrategy(context, props);
            case 'PageView':
                return new PageEventStrategy(context, props);
            default:
                throw Error("Unknown eventType");
        }
    };
    return EventStrategyResolver;
}());
export { EventStrategyResolver };
//# sourceMappingURL=EventStrategyResolver.js.map